import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import BrandStory from './components/BrandStory';
import PlatformAdvantage from './components/PlatformAdvantage';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import JoinCTA from './components/JoinCTA';

export default function AboutPage() {
  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 韩漫屋',
        url: 'http://pedionline.com/about',
        description: '了解韩漫屋品牌故事、平台优势与联系方式。韩漫屋是免费韩漫与漫画大全的聚集地，提供海量在线漫画资源。',
        isPartOf: { '@type': 'WebSite', name: '韩漫屋', url: 'http://pedionline.com/' },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://pedionline.com/' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://pedionline.com/about' },
        ],
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          {
            '@type': 'Question',
            name: '韩漫屋是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '韩漫屋是一个专注于韩国漫画的免费在线阅读平台，提供海量韩漫资源，涵盖恋爱、奇幻、动作、悬疑等多种题材。',
            },
          },
          {
            '@type': 'Question',
            name: '韩漫屋的漫画是否需要付费？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '韩漫屋所有漫画均完全免费阅读，无需任何付费订阅。',
            },
          },
          {
            '@type': 'Question',
            name: '韩漫屋有哪些漫画类型？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '韩漫屋涵盖恋爱、奇幻、动作、剧情、悬疑、搞笑、恐怖、日常等8大分类，共计超过5000部漫画作品。',
            },
          },
          {
            '@type': 'Question',
            name: '如何联系韩漫屋？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'hello@pedionline.com、微信公众号韩漫屋官方或新浪微博@韩漫屋官方微博联系我们。',
            },
          },
        ],
      }} />

      <Navbar />
      <Breadcrumb items={[
        { label: '首页', path: '/' },
        { label: '关于我们' },
      ]} />

      <main>
        <BrandStory />
        <PlatformAdvantage />
        <Reputation />
        <ContactSection />
        <JoinCTA />
      </main>

      <Footer />
    </>
  );
}